import { render, staticRenderFns } from "./ContactDetailsSkeleton.vue?vue&type=template&id=7164a553&scoped=true"
import script from "./ContactDetailsSkeleton.vue?vue&type=script&lang=ts"
export * from "./ContactDetailsSkeleton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7164a553",
  null
  
)

export default component.exports